import { useContext } from 'react';
import RegistrationContext from '../context/registrationContext';
import { Navigate } from 'react-router-dom';

const Success = () => {
    const { state } = useContext(RegistrationContext);
    const { date, time, code, venue } = state;

    if (code === '') return <Navigate to='/' />

    return (
        <>
            <div className="container mt-4">
                <div className="card mt-5">
                    <h3 className="text-center text-success card-head my-2">
                        Your Registration Was Successful
                    </h3>
                    <div className="card-body py-5">
                        <p className='lead my-3'>
                            <strong >Passcode</strong>: {code}
                        </p>
                        <small className='font-weight-bold'>Please come with it to the venue</small>

                        <p className='lead my-3'>
                            <strong>Date</strong> : {date}
                        </p>
                        <p className='lead my-3'>
                            <strong>Time</strong> : {time}
                        </p>
                        <p className='lead my-3'>
                            <strong>Venue</strong> : {venue}
                        </p>
                    </div>
                    <div className="card-footer">
                        <p>For more information call {' '}
                            <a href="tel:07032460187">07032460187</a>, {' '}
                            <a href="tel:09133896052">09133896052</a>
                        </p>
                    </div>
                </div>
                <br />
                <div className="container text-center px-0">
                    <a href="https://cloudnotte.com/thankyou"
                        className="text-center"
                        target="_blank" rel="noreferrer" style={myStyle}>
                        Click here to access more resources
                    </a>
                </div>
            </div>

        </>
    )
}


const myStyle = {
    fontSsize: "18px", fontFamily: "Open Sans, Helvetica, Arial, sans-serif",
    color: "#ffffff", textDecoration: "none", borderRadius: "5px",
    backgroundColor: " #f50057", padding: " 15px 30px", border: " 1px solid #f50057",
    display: "block"
}

export default Success;